export default function partition(arr, predicate) {
  return arr.reduce(function (prev, next) {
    (predicate(next) ? prev[0] : prev[1]).push(next);
    return prev;
  }, [[], []]);
}